import VideoCard from '@/components/feature/VideoCard';
import { videos } from '@/mocks/data';

export default function FeaturedVideos() {
  const featured = videos.filter((v) => v.featured).slice(0, 4);

  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            <i className="ri-fire-fill text-primary-500 mr-2"></i>
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">精选全网最火爆的爆料视频</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {featured.map((video) => (
          <VideoCard key={video.id} {...video} />
        ))}
      </div>
    </section>
  );
}